import { render } from "./praCase.vue?vue&type=template&id=f267783e&scoped=true"
import script from "./praCase.vue?vue&type=script&lang=js"
export * from "./praCase.vue?vue&type=script&lang=js"

import "./praCase.vue?vue&type=style&index=0&id=f267783e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f267783e"]])

export default __exports__